import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, useSlots } from 'vue';
import { ProductPropertyOption } from './product-properties';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPropertyModal',
  props: {
    name: null,
    title: null,
    options: null,
    selectedValue: null
  },
  emits: ["change-filter", "close"],
  setup(__props: any, { emit }: { emit: ({(e: 'change-filter', value: string, property: string): void, (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    name: string,
    title: string,
    options: ProductPropertyOption[],
    selectedValue?: string
}




const slots = useSlots();
const value = ref<string>('');

const hasLink = computed<boolean>(() => {
    return !!slots.link;
});

const hasContent = computed<boolean>(() => {
    return !!slots.content;
});

onMounted(() => {
    value.value = props.selectedValue;
});

function changeFilter(value: string) {
    emit('change-filter', value, props.name);
}

function close() {
    emit('close');
}

return { __sfc: true,props, emit, slots, value, hasLink, hasContent, changeFilter, close }
}

})